
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "@/store/httpClient";
import DatePicker from "@/components/DatePicker.vue";
import moment from "moment";
const Chart = require("chart.js");

@Component({
	components: {
		DatePicker,
	},
})
export default class RegistrationReport extends Vue {
	private chart: any = null;
	private registrationReport: any = [];
	private loading: boolean = false;
	private endDate: string = moment().format("YYYY-MM-DD");
	private startDate: string = moment().subtract(6, "month").format("YYYY-MM-01");
	private interval: number = 4;
	private intervals = [
		{ name: "pro Tag", value: 2 }, // value comes from TimeInterval enum
		{ name: "pro Woche", value: 3 }, // value comes from TimeInterval enum
		{ name: "pro Monat", value: 4 }, // value comes from TimeInterval enum
	];

	private mounted() {
		// Better not load the report on mount. Wait till data range is given.
	}

	private async loadReport() {
		try {
			this.loading = true;
			const response = await httpClient().get(
				`Report/GetRegistrations?from=${this.startDate}&to=${this.endDate}&interval=${this.interval}`
			);
			this.registrationReport = response.data;
			this.updateDiagram();
		} catch (err) {
			console.error("Loading registration reports failed.");
			console.error(err);
			this.$store.commit(
				"setSnackbarErrorText",
				"Fehler beim Laden der Reports. Siehe Konsole."
			);
		} finally {
			this.loading = false;
		}
	}

	private setStartDate(date: Date) {
		this.startDate = moment(date).format("YYYY-MM-DD");
	}
	private setEndDate(date: Date) {
		this.endDate = moment(date).format("YYYY-MM-DD");
	}

	private getDatasets() {
		const colors = [
			"#468641",
			"#A3FF00",
			"#00F4C4",
			"#123524",
			"#007EFF",
			"#005A99",
			"#4B0082",
			"#A146FF",
			"#FF0090",
			"#704214",
		];
		var datasets = [];
		var i = 0;
		for (const report of this.registrationReport) {
			const referenceData = report.registrations.map((c: any) => c.item2);
			let color = colors[i];
			if (report.region === "Alle") color = "#EFBB20"; // Blexon yellow
			if (report.region === "Schweiz") color = "#E11A27"; // Swiss red
			if (report.region === "Deutschland") color = "#000000"; // Germany black
			if (report.region === "Österreich") color = "#800020"; // Austria burgundy

			datasets.push({
				label: report.region, // Label shown above the graph
				borderColor: color, // Color of the line
				//borderColor: colors[i % colors.length], // Color of the line
				pointHitRadius: 2, // Size of the area where the point reacts to the mouse
				fill: false,
				tension: 0.3, // How "smooth" the line is. 0 for straight lines
				data: referenceData,
			});
			i++;
		}
		return datasets;
	}

	private getLabels() {
		if (!this.registrationReport) return [];
		// All reports have a registration entry for all intervals
		// so the first one can be taken to extract the labels
		const uniqueLabels: string[] = this.registrationReport[0].registrations.map(
			(r: any) => r.item1
		);

		if (this.interval === 2 || this.interval === 3) {
			// It's set to daily or weekly. Label should be day and month
			return uniqueLabels.map((l) => `${moment(l).format("DD.MM")}`);
		}
		if (this.interval === 4) {
			// It's set to monthly. Label should be month and year
			return uniqueLabels.map((l) => `${moment(l).format("MM.Y")}`);
		}
	}

	private updateDiagram() {
		const labels = this.getLabels();

		// Destroy the chart if one already exists.
		if (this.chart != null) {
			this.chart.destroy();
		}

		const ctx = (this.$refs.diagramCanvas as any).getContext("2d");
		this.chart = new Chart(ctx, {
			// The type of chart we want to create
			type: "line",
			// The data for our dataset
			data: {
				labels,
				datasets: this.getDatasets(),
			},
			// Configuration options go here
			// options: {
			// 	tooltips: {
			//         callbacks: {
			//             label: function(tooltipItem: any, data: any): any {
			//                 var procent = tooltipItem.xLabel
			//                 return ``;
			//             }
			//         }
			//     },
			// },
		});
		this.chart.update();
	}
}
